import React, { useState, useEffect, useRef } from 'react';
import GoldenLayoutComponent from './components/GoldenLayoutComponent';
import Header from './components/Header';
import './App.css';

function App() {
  const [isDarkMode, setIsDarkMode] = useState(() => {
    const savedTheme = localStorage.getItem('theme');
    return savedTheme ? savedTheme === 'dark' : true; // Default to dark theme
  });

  const layoutRef = useRef(null);

  useEffect(() => {
    document.body.classList.toggle('dark-mode', isDarkMode);
    document.body.classList.toggle('light-mode', !isDarkMode);
    localStorage.setItem('theme', isDarkMode ? 'dark' : 'light');
  }, [isDarkMode]);

  const toggleTheme = () => {
    setIsDarkMode(!isDarkMode);
  };

  const handleSymbolSubmit = (symbol) => {
    if (layoutRef.current && layoutRef.current.addChart) {
      layoutRef.current.addChart(symbol);
    }
  };

  return (
    <div className={`App ${isDarkMode ? 'dark' : 'light'}`}>
      <Header 
        isDarkMode={isDarkMode} 
        onThemeToggle={toggleTheme}
        onSymbolSubmit={handleSymbolSubmit}
      />
      <main className="app-content">
        <GoldenLayoutComponent 
          isDarkMode={isDarkMode}
          ref={layoutRef}
        />
      </main>
    </div>
  );
}

export default App;
